import stored_file_config from "@/components/StoredFile/config";

export default {
  singleLabel: "Maintenance externe",
  storeNamespace: 'external_maintenance',
  authFeature: 'external-maintenance',
  newRouteName: "ExternalMaintenanceNew",
  editRouteName: "ExternalMaintenanceEdit",
  listRouteName: "ExternalMaintenanceList",
  detailRouteName: "ExternalMaintenanceDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'ExternalMaintenanceForm',
  hideActionCsvButton: false,
  hideActionPdfButton: true,
  titleField: 'maintenance_number',
  showExtendedFilters: true,
  csvExportFilenamePrefix: 'controles-et-reparations',
  fields: [{
    name: 'maintenance_number',
    label: "Numéro",
    type: 'text',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: false,
    inCsvExport: true
  },
  {
    name: 'agency',
    label: "Agence",
    type: 'chosen',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    extendedFilter: true,
  },
  {
    name: 'group_slug',
    label: "Service",
    type: 'select',
    inForm: false,
    inList: true,
    inCsvExport: true,
    extendedFilter: true,
    formatter: (context, value) => value && value == 'instruments' ? 'IM' : (value && value == 'service_et_logistique' ? 'SL' : 'OC')
  },
  {
    name: 'reference',
    label: "Référence",
    type: 'chosen',
    inForm: false,
    inList: true,
    filterIn: true,
    sortable: true,
    inDetail: true,
    inCsvExport: true,
    detailLink: 'ReferenceDetail',
    formatter: (context, value) => value && value.product && value.product.name && value.internal_code ? value.product.name + " - " + value.internal_code : null
  },
  {
    name: 'reference_id',
    label: "Référence",
    type: 'chosen',
    inForm: true,
    inList: false,
  },
  {
    name: 'type_slug',
    label: "Type",
    type: 'select',
    inForm: true,
    required: true,
    inList: false,
    formatter: (context, value) => value ? context.$store.getters['external_maintenance/getType'](value) ? context.$store.getters['external_maintenance/getType'](value).text : null : null
  },
  {
    name: 'start_date',
    label: "Date d'ouverture",
    type: 'date',
    inForm: true,
    required: true,
    inList: true,
    sortable: true,
    extendedFilter: true,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'end_date',
    label: "Date du contrôle",
    type: 'date',
    inForm: false,
    required: false,
    inList: true,
    sortable: true,
    extendedFilter: true,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'type_slug',
    label: "Type",
    type: 'select',
    inForm: false,
    required: true,
    inList: true,
    sortable: true,
    filterIn: false,
    extendedFilter: true,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? context.$store.getters['external_maintenance/getType'](value) ? context.$store.getters['external_maintenance/getType'](value).text : null : null
  },
  {
    name: 'provider_id',
    label: "Organisme de contrôle",
    type: 'select',
    inForm: true,
    required: true,
    inList: false,
    sortable: true,
    inDetail: false,
  },
  {
    name: 'quotation',
    label: "Numéro de devis associé à la réparation",
    type: 'text',
    inForm: true,
    inList: false,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? value : null
  },
  {
    name: 'provider',
    label: "Prestataire",
    type: 'select',
    inForm: false,
    inList: true,
    filterIn: true,
    inDetail: true,
    detailLink: 'CompanyDetail',
    extendedFilter: true,
    inCsvExport: true,
    formatter: (context, value) => value ? value.name : null
  },
  {
    name: 'return_mode',
    label: "Transport",
    type: 'select',
    inForm: false,
    inList: true,
    inDetail: true,
    filterIn: true,
    extendedFilter: true,
    inCsvExport: true,
    formatter: (context, value) => value ? context.$store.getters['product/getReturnMode'](value).text : null
  },
  {
    name: 'reference',
    label: "Référence",
    type: 'chosen',
    extendedFilter: true
  },
  {
    // Filtre seul (dernière position) : origine, via product.from_mcs de la référence.
    name: 'from_mcs',
    label: "Origine",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    extendedFilter: true,
  },
  {
    name: 'invoice',
    label: "Facture",
    type: 'file',
    inForm: true,
    required: false,
    inList: false,
    filterIn: false,
    inDetail: false,
    formatter: (context, value) => value ? value : null
  },
  {
    name: 'price',
    label: "Prix",
    type: 'number',
    step: 0.01,
    inForm: true,
    required: false,
    inList: true,
    filterIn: false,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
  },
  {
    name: 'sap_order_number',
    label: "Numéro de commande SAP",
    type: 'text',
    inForm: true,
    required: false,
    inList: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    formatter: (context, value) => value ? value : null
  },
  {
    name: 'purchase_order',
    label: "Bon de commande SAP",
    type: 'file',
    inForm: true,
    required: false,
    inList: false,
    filterIn: false,
    inDetail: false,
    formatter: (context, value) => value ? value : null
  },
  {
    name: 'end_date',
    label: "Date du contrôle",
    type: 'date',
    inForm: true,
    required: false,
    inList: false,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'control_certificate',
    label: "Certificat contrôle obligatoire",
    type: 'file',
    inForm: true,
    required: false,
    filterIn: false,
    inDetail: false,
    inCsvExport: true,
    formatter: (context, value) => value ? 'oui' : 'non',
    inFormCondition: (form) => form.type_slug == 'calibration',
  },
  {
    name: 'stored_files',
    label: "Fichiers joints",
    type: 'group_repeater',
    inForm: true,
    fields: [{
      name: 'file',
      label: "Fichier",
      type: 'file',
      inForm: true,
    }]
  },
  {
    name: 'additional_informations',
    label: "Observations",
    type: 'textarea',
    inForm: true,
    required: false,
    inList: false,
    filterIn: false,
    inDetail: true,
  },
  {
    name: 'created_at',
    label: "Création",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: false,
    inPdfExport: false,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  {
    name: 'created_at',
    label: "Création",
    type: 'date',
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: true,
    formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
  },
  {
    name: 'stored_files',
    label: "Fichiers joints",
    type: 'list',
    icone: 'folder',
    config: stored_file_config,
    fields: ['file', 'type_slug']
  }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ExternalMaintenance/config.js